export default {
  index: [
    {
      path: '/corporateservices',
      component: resolve => require(['./corporateservicesIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/corporateservices/_router.js